export * from './electron.fake.service';
export * from './electron.service';